import * as React from 'react';
import * as styles from './Notice.css';
import { ContentLayout } from '../ContentLayout';
export var Notice = function Notice(_ref) {
  var text = _ref.text;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['notice-wrapper']
  }, /*#__PURE__*/React.createElement(ContentLayout, null, /*#__PURE__*/React.createElement("div", {
    className: styles['notice'],
    dangerouslySetInnerHTML: {
      __html: text
    }
  })));
};